import { InspectionItem } from "src/app/types/inspection.type";
import { BuildServices } from "./generic-route-event.model";
import { _NonServicePeriod } from '.';
import { NonServicePeriod, NonServicePeriodTypeEnum } from "src/app/types/non-service-period.type";
import { InspectionPage } from "src/app/pages/inspection/inspection.page";

export class PostTripInspection extends _NonServicePeriod {

  constructor(data: NonServicePeriod, services: BuildServices) {
    super(data, services);
    this.headerInfo.type = 'LABEL.postTrip';
    this.nonServicePeriods.nonServicePeriodType = NonServicePeriodTypeEnum.PostTrip;
  }

  public type = 'post-trip';

  private alertFailedInspectionOptions = {
    cssClass: 'alert-wrapperz',
    header: this.translateSvc.translate('TITLE.inspFailed'),
    message: (<NonServicePeriod>this.value).inspectionFailureMessage || this.translateSvc.translate('LABEL.criticalInspFailed'),
    buttons: [{
      text: this.translateSvc.translate('ACTION.ok').toUpperCase(),
      cssClass: 'primary',
    }],
  };

  private onInspectionDismiss = (success: boolean, inspectionItems: InspectionItem[]) => new Promise(async resolve => {
    this.started = true;
    const now = new Date();

    await this.routeProviderSvc.startNonServicePeriod(NonServicePeriodTypeEnum.PostTrip, now);
    await this.routeProviderSvc.finishNonServicePeriod(NonServicePeriodTypeEnum.PostTrip);
    await this.dispatchSvc.addInspectionReport(inspectionItems, NonServicePeriodTypeEnum.PostTrip);
    this.completed = true;

    if (success) {
      await this.modalController.dismiss();
      resolve(true);
      return;
    }

    // inspection failed
    const inspection = await this.alertController.create(this.alertFailedInspectionOptions);
    await inspection.present();
    await this.dispatchSvc.logout();
    resolve(false);
  });

  protected async start() {
    await this.routeProviderSvc.startNonServicePeriod((<NonServicePeriod>this.value).nonServicePeriodType);
    if (!(<NonServicePeriod>this.value).inspectionItems?.length) { return; }
    const inspectionModal = await this.modalController.create({
      cssClass: 'parascope-full-modal',
      backdropDismiss: false,
      component: InspectionPage,
      componentProps: {
        nonServicePeriod: this.value,
        onComplete: async (success: boolean, inspectionItems: InspectionItem[]) =>
          await this.onInspectionDismiss(success, inspectionItems),
      },
    });
    await inspectionModal.present();
  }

}
